import { Button, H2 } from "@sellar-io/components";
import { useFullPageDialogContext } from "../../../../../../../../components/modal/useFullPageDialogContext";
import { SellarCreditTwoDialogPageEnum } from "../types/SellarCreditTwoDialogPageEnum";
import { SellarCreditTwoDialogPage } from "./SellarCreditTwoDialogPage";

export const TwoAccountVerificationGetStarted = () => {
  const { setPage } = useFullPageDialogContext();

  return (
    <SellarCreditTwoDialogPage contentClassName="justify-center gap-6">
      <H2>Verify your account</H2>
      <p>
        To continue with Sellar Credit, we'll securely verify your business with
        our credit provider, Two.
      </p>

      <div className="w-full rounded-xl bg-zinc-100 p-4 text-left">
        <p className="font-semibold">
          Depending on your account you may be asked to
        </p>
        <ul className="mt-1 list-disc pl-5">
          <li>Verify using your Sellar account email</li>
          <li>Complete a secure bank-based verification</li>
        </ul>
      </div>

      <p>This usually takes less than 2 minutes.</p>

      <div className="flex w-full flex-col gap-2">
        <Button
          className="w-full"
          onClick={() => setPage(SellarCreditTwoDialogPageEnum.LOGIN_CHECK)}
        >
          CONTINUE
        </Button>

        <Button
          className="w-full"
          onClick={() => setPage(SellarCreditTwoDialogPageEnum.INVITE_DIRECTOR)}
          color="tertiary"
        >
          I DON'T HAVE ACCESS TO OUR BANKING INFORMATION
        </Button>
      </div>
    </SellarCreditTwoDialogPage>
  );
};
